module.exports = __webpack_public_path__ + "static/classes_bg-7492f69cd7027a0af34af318731910e4.svg";